import { createStore } from 'vuex'
import auth from './modules/auth'
import characters from './modules/characters'
import conversations from './modules/conversations'

export default createStore({
  modules: {
    auth,
    characters,
    conversations
  }
}) 